import React from 'react';
import { connect } from 'react-redux'
import {
  show_archive_sidebar_report_actions,
  hide_archive_sidebar_report_actions,
  get_project,
  destroy_report,
  // reports_archive,
  project_archive,
  restore_report
} from '../actions'
import { Link, Redirect } from 'react-router-dom'
import Pagination from './Pagination'
import Loading from './Loading';
import {
  is_logged_on,
  is_validating
 } from "../helpers"

const mapStateToProps = state => {
  return {
    report: state.report
  };
};

const mapDispatchToProps = dispatch => {
    return {
      // getReports: (page) => dispatch ( reports_archive(page) ),
      destroyReport: (id, page) => dispatch ( destroy_report(id, page) ),
      getProject: (id) => dispatch ( get_project(id) ),
      restoreReport: (report_id, page) => dispatch ( restore_report(report_id, page) ),
      projectArchive: (report_id, page) => dispatch( project_archive(report_id, page) ),
      showActions: () => dispatch ( show_archive_sidebar_report_actions() ),
      hideActions: () => dispatch ( hide_archive_sidebar_report_actions() )
    }
}

class ConnectedArchives extends React.Component {
  constructor () {
    super()
    this.state = {
      clickedId: ''
    }
  }

  setCurrent(id) {
    this.setState({clickedId: id})
  }

  resetCurrent() {
    this.setState({clickedId: ''})
  }

  destroyReport(report_id) {
    this.setState({clickedId: ''})
    const {page} = this.props.report.report.pagination
    this.props.destroyReport(report_id, page)
  }

  restoreReport(report_id) {
    this.setState({clickedId: ''})
    const {page} = this.props.report.report.pagination
    this.props.restoreReport(report_id, page)
  }

  componentDidMount() {
    const {id} = this.props.match.params
    console.log(id)
    this.props.showActions()
    this.props.projectArchive(id, 1)
  }

  componentWillUnmount() {
    this.props.hideActions()
  }

  render() {
    if ( !is_validating() && !is_logged_on() ) {
      return <Redirect to="/login" />
    }

    const { fetching, fetched } = this.props.report;

    if ( fetching || ! fetched ) {
      return (
       <Loading />
      )
    }

    const reports = (typeof( this.props.report.report.archives ) === "undefined") ? [] : this.props.report.report.archives


    const { pagination } = this.props.report.report;

    return (
      <div className="collection with-header">
				<div className="collection-header red darken-1 white-text">
					<span className="flow-text">Project: {this.props.report.report.name} | Archived Instances</span>
					<i className="material-icons right">delete</i>
				</div>
				<table className="bordered striped highlight responsive-table">
					<thead>
						<tr>
							<th>Project Name</th>
							<th>Date Archived</th>
              {
                // <th>User</th>
              }
							<th>Details</th>
							<th>Status</th>
							<th>Actions</th>
						</tr>
					</thead>
				 	<tbody>
						{reports.map(function(report){
							const {id, name, deleted_at, entries, new_entries, removed} = report;
              const current = this.state.clickedId

              let links
              if (report.id !== current) {
                links = (
                  <div className="meta" onMouseLeave={(e) => {
                    this.resetCurrent()
                  }}>
                    <Link className="c-darkgrey" to={`/reports/${report.id}/entries`}>View</Link> |
                    <Link
                      className="red-text"
                      to="#"
                      onClick={(e)=>{
                        e.preventDefault()
                        this.setCurrent(report.id)
                      }}
                      >Permanently Delete</Link>
                  </div>
                )
              } else {
                links = (
                  <div className="meta">
                    <Link className="c-darkgrey" to="#" onClick={(e)=>{
                      e.preventDefault()
                      this.resetCurrent()
                    }}>Cancel</Link> |
                    <Link
                      className="red-text"
                      to="#"
                      onClick={(e)=>{
                        e.preventDefault()
                        this.destroyReport(report.id)
                      }}
                      >Are you sure?</Link>
                  </div>
                )
              }

							return (
								<tr key={id}>
									<td>
										<Link className="view" to={`/reports/${report.id}/entries`}>{name}</Link>
                    { links }
									</td>
									<td>{new Date(deleted_at).toLocaleDateString()}, {new Date(deleted_at).toLocaleTimeString()}</td>
                  {
                    // <td>user here</td>
                  }
									<td>
                    <small><p>{entries} Rows Total</p></small>
                    <small><p>{new_entries} Unreviewed Rows</p></small>
                    <small><p>{removed} Deleted Rows</p></small>
									</td>
									<td>
										<i className="material-icons c-grey">restore</i>
									</td>
									<td>
										<button className="btn red darken-1 waves-effect waves-light" onClick={(e)=>{
                      e.preventDefault()
                      this.restoreReport(report.id)
                    }}>RESTORE</button>
									</td>
								</tr>
							)
						}, this)}
			 		</tbody>
				</table>
        <Pagination pagination={pagination} fetchPage={this.props.projectArchive}/>
      </div>
    )
  }

}

const Archives = connect(mapStateToProps, mapDispatchToProps)(ConnectedArchives);

export default Archives;



// WEBPACK FOOTER //
// ./src/js/components/ProjectArchives.js